var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader"}},[_c('div',{staticClass:"app-loader d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }